import React, { ReactNode, createContext, useContext, useState } from 'react';

type EscapeContextType = {
  isEscapeBlocked: boolean;
  blockEscape: () => void;
  unblockEscape: () => void;
};

const EscapeContext = createContext<EscapeContextType | undefined>(undefined);

export const EscapeProvider = ({ children }: { children: ReactNode }) => {
  const [isEscapeBlocked, setIsEscapeBlocked] = useState(false);

  const blockEscape = () => setIsEscapeBlocked(true);
  const unblockEscape = () => setIsEscapeBlocked(false);

  return <EscapeContext.Provider value={{ isEscapeBlocked, blockEscape, unblockEscape }}>{children}</EscapeContext.Provider>;
};

export const useEscapeContext = () => {
  const context = useContext(EscapeContext);
  if (!context) {
    throw new Error('useEscapeContext must be used within an EscapeProvider');
  }
  return context;
};
